export default function HowIBuildSystems() {
  const principles = [
    {
      title: "Architecture First",
      description:
        "Every system begins with thoughtful architecture. I design database schemas, API structures, and service boundaries before writing production code.",
    },
    {
      title: "Performance Focused",
      description:
        "I optimize queries, reduce latency, and design scalable data flows to ensure systems perform efficiently under real-world usage.",
    },
    {
      title: "Clean & Maintainable",
      description:
        "I prioritize readable code, modular services, and clear documentation to ensure long-term maintainability and team scalability.",
    },
  ];

  return (
    <section className="relative py-32 bg-white overflow-hidden">

      {/* Subtle Background Atmosphere */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-blue-50 blur-3xl opacity-60"></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">

        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-sm uppercase tracking-widest text-blue-600 font-semibold mb-4">
            Engineering Approach
          </p>

          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900">
            How I Build Systems
          </h2>

          <p className="text-lg text-slate-600 mt-4 max-w-2xl mx-auto leading-relaxed">
            My development process focuses on scalable architecture,
            performance optimization, and long-term system reliability.
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-3 gap-10">

          {principles.map((item, index) => (
            <div
              key={item.title}
              className="
                group
                bg-white
                border border-slate-200
                rounded-2xl
                p-10
                transition duration-300
                hover:-translate-y-2
                hover:shadow-xl
                hover:shadow-blue-500/10
              "
            >
              {/* Accent Line */}
              <div className="w-10 h-1 bg-blue-600 mb-6 rounded-full opacity-80 group-hover:w-16 transition-all duration-300"></div>

              <h3 className="text-xl font-semibold text-slate-900 mb-4 tracking-tight">
                {item.title}
              </h3>

              <p className="text-slate-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}